(() => {
  const syncQuickControls = () => {
    const url = new URL(location.href);
    const newest = document.querySelector('[data-catalog-newest]');
    if (newest) {
      newest.dataset.selected = String(url.searchParams.get('sort_by') === 'created-descending');
      url.searchParams.set('sort_by', 'created-descending');
      url.searchParams.delete('page');
      newest.href = url.href;
    }
    const filters = document.querySelector('[data-catalog-panel="filters"]');
    if (filters) {
      const count = [...url.searchParams].filter(([key, value]) => key.startsWith('filter.') && value !== '').length;
      filters.dataset.filterCount = String(count);
      filters.dataset.selected = String(count > 0);
    }
  };
  syncQuickControls();
  window.addEventListener('popstate', syncQuickControls);
  const results = document.querySelector('.main-products-grid');
  if (results) new MutationObserver(syncQuickControls).observe(results, { childList: true, subtree: true });
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-catalog-panel]');
    if (!trigger) return;
    const drawer = document.getElementById('facet-filters');
    if (!drawer || typeof drawer.open !== 'function') return;
    const targets = { catalog: '.catalog-directory', filters: '.facets__filters details:not(#filter-sort)', sort: '#filter-sort' };
    const target = drawer.querySelector(targets[trigger.dataset.catalogPanel]);
    if (target?.tagName === 'DETAILS') target.open = true;
    drawer.dataset.catalogPanel = trigger.dataset.catalogPanel;
    const heading = drawer.querySelector('#facets-title');
    if (heading) heading.textContent = trigger.querySelector('span').textContent;
    drawer.open(trigger);
    requestAnimationFrame(() => {
      const content = drawer.querySelector('.drawer__content');
      if (content && target) content.scrollTop += target.getBoundingClientRect().top - content.getBoundingClientRect().top - 12;
    });
  });
  const currentUrl = new URL(location.href);
  if (/\/collections\/all\/?$/.test(currentUrl.pathname) && !currentUrl.searchParams.get('sort_by')) {
    currentUrl.searchParams.set('sort_by', 'created-descending');
    location.replace(currentUrl.href);
    return;
  }
  const style = currentUrl.searchParams.get('directory_style');
  if (!['tree', 'cards', 'compact'].includes(style)) return;
  document.documentElement.dataset.directoryStyle = style;
  const names = { tree: 'A｜經典樹狀目錄', cards: 'B｜卡片式目錄', compact: 'C｜精簡清單目錄' };
  document.title = `${names[style]} — ${document.title}`;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.catalog-directory a, .catalog-mobile-bar a');
    if (!link) return;
    const target = new URL(link.href);
    if (target.origin !== location.origin) return;
    target.searchParams.set('directory_style', style);
    link.href = target.href;
  });
})();
